import {
  Editor,
  posToDOMRect,
  ReactRenderer,
} from '@tiptap/react';
import {
  computePosition,
  flip,
  shift,
} from '@floating-ui/dom';

import { MentionList } from './MentionList';

const updatePosition = (editor: Editor, element: HTMLElement) => {
  const virtualElement = {
    getBoundingClientRect: () => posToDOMRect(editor.view, editor.state.selection.from, editor.state.selection.to),
  };

  computePosition(virtualElement, element, {
    placement: `bottom-start`,
    strategy: `absolute`,
    middleware: [shift(), flip()],
  }).then(({ x, y, strategy }) => {
    element.style.width = `max-content`;
    element.style.position = strategy;
    element.style.left = `${x}px`;
    element.style.top = `${y}px`;
  });
};

export const suggestion = (values: string[]) => {
  return {

    items: ({ query }) => {
      return values
        .filter(item => item.toLowerCase().startsWith(query.toLowerCase()))
        .slice(0, 5);
    },

    render: () => {
      let component;

      const destroy = () => {
        if (!component) return;

        component.element.remove();
        component.destroy();
        component = null;
      };

      return {
        onStart: props => {
          component = new ReactRenderer(MentionList, {
            props,
            editor: props.editor,
          });

          if (!props.clientRect) {
            return;
          }

          component.element.style.position = `absolute`;
          // Above the Drawer (z-55) and Modal (z-60) so mentions work inside the notes drawer
          component.element.style.zIndex = `70`;

          // Mount inside an open headlessui DialogPanel (if any) so clicking a mention isn't treated as an outside click that closes it.
          // Headless UI only counts clicks inside the panel as inside, not the outer [role="dialog"] wrapper
          const dom = props.editor.view.dom;
          const container = dom.closest(`[id^="headlessui-dialog-panel-"]`) ?? dom.closest(`[role="dialog"]`) ?? document.body;
          container.appendChild(component.element);
          updatePosition(props.editor, component.element);
        },

        onUpdate(props) {
          if (!component) return;

          component.updateProps(props);

          if (!props.clientRect) {
            return;
          }

          updatePosition(props.editor, component.element);
        },

        onKeyDown(props) {
          if (props.event.key === `Escape`) {
            destroy();

            return true;
          }

          return component?.ref?.onKeyDown(props);
        },

        onExit() {
          destroy();
        },
      };
    },
  };
};
